import {
  Briefcase,
  Link,
  Lock,
  Mic,
  Music,
  Shield,
  User,
  Video,
} from "lucide-react";
import type { ComponentType } from "react";

import type { ContractTemplateIconId } from "@/types/contractIntelligence.types";

type LucideIconComponent = ComponentType<{
  size?: number;
  className?: string;
}>;

const ICONS: Record<ContractTemplateIconId, LucideIconComponent> = {
  shield: Shield,
  music: Music,
  link: Link,
  briefcase: Briefcase,
  lock: Lock,
  mic: Mic,
  video: Video,
  user: User,
};

interface TemplateIconProps {
  name: ContractTemplateIconId;
  className?: string;
}

export function TemplateIcon({ name, className }: TemplateIconProps) {
  const Icon = ICONS[name] ?? Briefcase;
  return <Icon className={className} size={16} aria-hidden="true" />;
}
